import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API_BASE });

// Build a direct file URL that opens in a new tab (uses ?token=... since
// the browser does NOT send the Authorization header for plain <a> links).
export const fileUrl = (fileId) => {
  if (!fileId) return "";
  const t = localStorage.getItem("smipl_token");
  return `${API_BASE}/files/${fileId}/download?token=${encodeURIComponent(t || "")}`;
};

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("smipl_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("smipl_token");
      localStorage.removeItem("smipl_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};
